import { createContext } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/context/context-key.js';
export const dynamicPhoneNumberContext = createContext('dynamic-phone-number');
export const dynamicLinksContext = createContext('dynamic-links');
//# sourceMappingURL=interfaces.js.map